import React from 'react';
import OlMapView from './olmapview';
import $ from 'jquery';
import {Link} from 'react-router-dom';
import Livingplaces from '../../models/livingplacecoll';
import Livingplaces_miscdata from '../../models/miscStates';
import Searcher from './searcher'


export default class OlAddressMapView extends React.Component {
	constructor(props) {
		super(props);
		
	}
	componentDidMount() {

	  }
	  render() {
		  
		    return (<div className="pagecontainer">
				    <nav className="navbar navbar-default">
					  <div className="container-fluid header">
					    <div className="navbar-header">
					    <div className="row">
					    <div className="col-xs-12"><h4>Wohnstandort auswählen</h4>{this.props.match.params.placeid === "2" ? <h4>(Vergleichsstandort)</h4> : /*<a href="static/pdf/moreOOE_hilfe.pdf" target="_blank">Hilfe (PDF)</a>*/''}</div>
					    </div>
					  </div>
					  </div>
					</nav>
		    		<OlMapView basemapAtType='normal' id={ this.props.match.params.placeid } mapPurpose = {"selectlivingPlaceAddress"} styleclass={"inframap"}>
		    		<AddressSearchBox id={ this.props.match.params.placeid }/>
		    		</OlMapView>
		    		</div>
		    );
		  }
}


class AddressSearchBox extends React.Component {
	constructor(props) {
		super(props);
		var lpmodel = window.datastore.lps.get(this.props.id);
		this.state = {modelrdy: false}
		if (lpmodel){
			this.state = {name: lpmodel.get('name'), xy: lpmodel.get('xy'), modelrdy: true};
		}		
		
	}
	changeaddrData (xystr, name) {
	    this.setState({
	      xy: xystr,
	      name: name,
	      modelrdy: true
	    });
	  }
	componentDidMount() {
		var id = this.props.id;
		var comp = this;
		window.datastore.lps.on("add", function(livingplaceModel) {
			  if (livingplaceModel.id === id) {
				  var xy = livingplaceModel.get('xy')
				  var name = livingplaceModel.get('name')
				  comp.changeaddrData(xy, name)
			  }
			});
		
	}
	componentWillUnmount() {
	    // Ensure that we clean up any dangling references when the component is
	    // destroyed.
		Livingplaces.off("add")
	}
	render() {
		var coordinates; 
		if (this.state && typeof this.state.xy !== 'undefined') {
			coordinates = 'Lon: ' + (Math.round(this.state.xy[0] * 10000) / 10000) + ', ' + 'Lat: ' + (Math.round(this.state.xy[1] * 10000) / 10000)
		} else {
			coordinates = '';
		}
		
		var addressname; 
		if (this.state && typeof this.state.xy !== 'undefined') {
			addressname = this.state.name
		} else {
			addressname = 'Bitte direkt auf die gewünschte Lage in der Karte klicken oder Standort über Suche ermitteln!';
		}

	    return (
	    		<div className="map-address-search panel panel-default">
	    		  <div className="panel-heading">Wohnstandort</div>
	    		  <div className="panel-body">
	    		  <div className="addrcoords">{coordinates}</div>
	    		  <div>{addressname}</div>
	    		  <AcceptPlaceButton modelrdy={this.state.modelrdy} id={this.props.id}/>
	    		  <hr />
	    		  <Searcher id={this.props.id} bbeventname={"searched"}/>
	    		</div>
	    		</div>
	    )
	}
}


class AcceptPlaceButton extends React.Component {
	constructor(props) {
		super(props);
	}
	componentDidMount() {
	  }
	  render() {
		  var button;
		  if (this.props.modelrdy) {
			  var link = "/wohnstandorte/"+this.props.id+"/infrastruktur";
			  button = <Link to={link}><button className="btn btn-primary placeacceptbutton">Übernehmen</button></Link>
		  }
		  else {
			  button = '';
		  }
		    return (
		    		<div>{button}</div>
		    );
		  }
}





// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/oladdressmapview.js